// extra_damage_requires_damage_type (2026-10-07, Psion Pyrokinetic L30 "Overheat": "All sources of Fire damage you deal deal an
// additional 2d8 Fire"). An extra_damage_roll rider carrying the layer fires only when the HOST it rides — the item being used
// (ability / spell / menta, or the weapon in a weapon phase) — deals one of the listed damage types. A weapon with no damage_type
// of its own deals the caster's main_weapon_damage_type (damage_type_roll's fallback). No layer = always fires.
// Lanes: damage-type-roll.ts (caster extra_damage_roll passives + item-hosted riders) and weapon-attack-extra-damage.ts (the
// weapon lane's caster passives). The legacy PHP copy is ft_extra_damage_damage_type_gate_allows() — retirement row R-146.

export const EXTRA_DAMAGE_REQUIRES_DAMAGE_TYPE = 'extra_damage_requires_damage_type';

/** `required`: the rider's listed damage type ids; `dealt`: the host's damage type ids. Case-insensitive; an empty `required` passes. */
export function extraDamageTypeGateAllows(required: readonly string[], dealt: readonly string[]): boolean {
  const want = required.map((id) => String(id ?? '').trim().toUpperCase()).filter(Boolean);
  if (want.length === 0) return true;
  const have = new Set(dealt.map((id) => String(id ?? '').trim().toUpperCase()).filter(Boolean));
  return want.some((id) => have.has(id));
}
